/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOnboardingEvent } from '../models/api-response-onboarding-event';
import { track } from '../fn/onboarding-event-client-api/track';
import { Track$Params } from '../fn/onboarding-event-client-api/track';

@Injectable({ providedIn: 'root' })
export class OnboardingEventClientApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `track()` */
  static readonly TrackPath = '/v1/api/onboarding-event-client/track';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `track()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  track$Response(params: Track$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOnboardingEvent>> {
    return track(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `track$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  track(params: Track$Params, context?: HttpContext): Observable<ApiResponseOnboardingEvent> {
    return this.track$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOnboardingEvent>): ApiResponseOnboardingEvent => r.body)
    );
  }

}
